import { r as registerInstance, h, g as getElement } from './index-5faac9d7.js';
import { c as classnames } from './index-43880fda.js';
import { d as debounce_1 } from './debounce-e0de1804.js';
import { aa as pesIconSizes, ak as pesIconMirrorDirection, o as BUSINESS, A as ALLPRODUCTS, a8 as DEBOUNCED_HANDLER_DELAY } from './currency-49e0d692.js';
import { B as BUSINESS_ID_PARAM_NAME } from './navigation-83d2f79a.js';
import { b as isIndexDBEnabled, an as indexDBBreadcrumbs, aH as SprykerProductsSelectorConfig, aF as SprykerCommerceConnector, c as isPublicEnvironment, aD as SprykerCategoriesByBusiness, ay as HmcCategories, t as tryParse, a3 as getConsumerSpecificData, n as isEmpty } from './index-39f51a91.js';
import { i as isMobile } from './utils-6c8f178b.js';
import './product-card-78a466f2.js';
import { s as store } from './pes-router-store-498d2799.js';
import './store-a2f488b2.js';
import { W as setQueryParam, V as updatePageLoadData } from './analytics-74fe4f64.js';
import './_commonjsHelpers-7db8bc26.js';
import './_nodeUtil-549406aa.js';
import './toNumber-d92ee08f.js';
import './isSymbol-8fefec05.js';
import './analytics-b3108572.js';
import './lodash-7f024380.js';
import './_Stack-cf94d4e7.js';
import './pick-8e119733.js';
import './_basePickBy-19dc1369.js';
import './_arrayLikeKeys-26c55d84.js';
import './isEmpty-ea893565.js';
import './toString-568546f3.js';
import './_isIndex-3036d479.js';
import './keysIn-b6895676.js';
import './hasIn-833a7ad2.js';
import './_flatRest-cc9038d0.js';
import './_baseFlatten-eecfdcde.js';
import './pes-product-link-74e48119.js';
import './utils-cdf9de4e.js';
import './helpers-cd261aee.js';
import './tslib.es6-613ce1cd.js';
import './index-67820103.js';
import './utils-2fbd0743.js';
import './_baseFor-a28737de.js';
import './_copyObject-3791899f.js';
import './constants-7d3b1dc0.js';
import './number-fcf5283d.js';
import './utils-1b416b6b.js';
import './index-54dd34b7.js';

const allProductsCss = ".all-products{background-color:#f7f7f7}@media screen and (max-width: 979px){.all-products{display:flex;flex-direction:column-reverse}}.all-products__main-content{position:relative}@media screen and (min-width: 980px){.all-products__main-content{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;padding-bottom:30px}.all-products__main-content--menu-opened::after{content:\"\";position:absolute;left:0;right:0;top:58px;bottom:0;background:#666666;opacity:0.7;z-index:1}}@media screen and (max-width: 979px){.all-products__header{margin:0;color:#333333;text-align:center;padding:24px 0 16px;font-size:24px;line-height:36px;font-weight:700;width:100%}}@media screen and (min-width: 980px){.all-products__header{display:none}}@media screen and (min-width: 980px){.all-products__section{display:flex;flex-wrap:wrap;width:1200px;max-width:1200px;padding:0;box-sizing:border-box}.all-products__section *,.all-products__section *::before,.all-products__section *::after{box-sizing:inherit}}.all-products__section--inactive{display:none}.all-products__section-title-wrapper{display:none}@media screen and (min-width: 980px){.all-products__section-title-wrapper{display:flex;flex-basis:100%;height:52px}}.all-products__section-title{display:inline-flex;align-items:center;padding:0 10px;font-size:22px;line-height:30px;font-weight:700;color:#333333;text-decoration:none}.all-products__section-title-icon{position:relative;top:2px}:host(:not([dir=\"rtl\"])) .all-products__section-title-icon{left:8px}:host([dir=\"rtl\"]) .all-products__section-title-icon{right:8px;transform:scaleX(-1)}@media screen and (min-width: 980px){.all-products__top-categories{display:block;width:100%}}.all-products__menu-category{display:none}@media screen and (min-width: 980px){.all-products__menu-category{position:relative;display:block;width:25%;padding:6px 10px 0}}@media screen and (min-width: 980px){.all-products__top-runners{display:flex;flex-flow:wrap;align-content:flex-start;width:75%}}";

const AllProducts = class {
  handleMenuCategoryOpen() {
    this.menuCategoryOpened = true;
  }
  handleMenuCategoryClose() {
    this.menuCategoryOpened = false;
  }
  async activeBusinessIdWatcher(id) {
    this.fetchCategoriesByBusinessId(id);
    if (!isIndexDBEnabled())
      return;
    const currentPageStorageKey = id ? `${BUSINESS}/${id}` : `${ALLPRODUCTS}/`;
    try {
      const result = await indexDBBreadcrumbs.getExistingOrUpdateForBusiness({
        storageName: this.storageName,
        currentPageStorageKey,
        id,
        getActiveBusinessCallBack: this.getActiveBusiness,
      });
      if (!(result === null || result === void 0 ? void 0 : result.length))
        return;
      this.breadcrumbsFromStorage = result;
    }
    catch (e) {
      console.error(`[PES]: ${currentPageStorageKey} breadcrumbs can not be fetched or updated from indexDB ${this.storageName} storage`, e);
    }
  }
  fetchCategoriesByBusinessId(id) {
    if (!id || id in this.businessCategoriesMap) {
      return;
    }
    this.requestCategoriesByBusinessId(id).then((res) => {
      this.setBusinessCategoriesMap(id, res);
    });
  }
  async requestProductSelectorConfig() {
    if (!this.selectorConfigUrl) {
      return this.getProductSelectorConfig();
    }
    const { error, result } = await SprykerProductsSelectorConfig.fetchProductsSelectorConfig(this.selectorConfigUrl);
    if (error) {
      console.error('[PES]: Could not fetch products selector config', error);
      throw error;
    }
    return result;
  }
  async requestCommerceConnectorSettings() {
    if (!this.commerceConnectorUrl) {
      return;
    }
    const { error, result } = await SprykerCommerceConnector.getCommerceConnector({ url: this.commerceConnectorUrl });
    if (error) {
      console.error('[PES]: Could not fetch the commerce connector api', error);
      throw error;
    }
    return result;
  }
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.changeActiveLine = (id) => {
      this.activeBusinessId = id;
    };
    this.getCountryCode = (countryCode) => {
      return isPublicEnvironment() ? countryCode.toLowerCase() : countryCode;
    };
    this.setActiveBusinessId = (businessId, sourceId) => {
      this.activeBusinessId = this.activeBusinessId === businessId ? null : businessId;
      const searchParams = new URLSearchParams(window.location.search);
      if (!this.isPBS) {
        setQueryParam(searchParams, BUSINESS_ID_PARAM_NAME, sourceId);
        window.history.replaceState(null, '', `?${searchParams.toString()}${window.location.hash}`);
      }
      updatePageLoadData({ pageCategory: sourceId });
    };
    this.requestCategoriesByBusinessId = (id) => {
      if (this.categoriesUrl) {
        return this.getCategoriesByBusinessIdWithHmc(id);
      }
      return this.getCategoriesByBusinessId(id);
    };
    this.getCategoriesByBusiness = async (id) => {
      try {
        const params = new URLSearchParams(this.categoriesUrl.split('?')[1]);
        const QueryParams = Object.fromEntries(params);
        const { 'country-code': countryCode, 'language-code': languageCode } = QueryParams;
        const { error: categoriesByBusinessError, result: categoriesByBusinessResult, } = await SprykerCategoriesByBusiness.fetchCategoriesByBusiness(this.categoriesUrl.replace(':id', id));
        if (categoriesByBusinessError) {
          throw new Error(`Could not fetch categories By Business api:\n${categoriesByBusinessError.message}`);
        }
        this.categoriesByBusinessId = categoriesByBusinessResult;
        const pimIds = this.categoriesByBusinessId.map((category) => category.id).join();
        const { error: hmcCategoriesError, result: hmcCategoriesResult, } = await HmcCategories.fetchCategoriesWithHMC({
          countryCode: this.getCountryCode(countryCode),
          languageCode,
          pimIds,
          hmcBanner: 'true',
        });
        if (hmcCategoriesError) {
          throw new Error(`Could not fetch hmc visibility information for categories:\n${hmcCategoriesError.message}`);
        }
        this.categoriesListWithHMC = hmcCategoriesResult;
      }
      catch (error) {
        console.log('[PES] ', error);
      }
    };
    this.getCategoriesByBusinessIdWithHmc = async (id) => {
      var _a;
      await this.getCategoriesByBusiness(id);
      if (!this.categoriesByBusinessId && !this.categoriesListWithHMC)
        return [];
      const CategorieswithHMC = {};
      this.categoriesListWithHMC.forEach((hmcCategory) => {
        const { pimId, hmcBanner } = hmcCategory;
        if (hmcBanner)
          CategorieswithHMC[pimId] = hmcBanner;
      });
      return (_a = this.categoriesByBusinessId) === null || _a === void 0 ? void 0 : _a.map((category) => {
        const hmcBanner = CategorieswithHMC[category.id];
        if (hmcBanner) {
          return Object.assign(Object.assign({}, category), { hmcBanner });
        }
        return category;
      });
    };
    this.setBusinessCategoriesMap = (id, businessCategory) => {
      this.businessCategoriesMap = Object.assign(Object.assign({}, this.businessCategoriesMap), { [id]: businessCategory });
    };
    this.getActiveBusiness = (businessId) => {
      var _a;
      return (_a = this.businesses) === null || _a === void 0 ? void 0 : _a.find((business) => (business === null || business === void 0 ? void 0 : business.id) === businessId);
    };
    this.resizeWindow = () => {
      this.isMobile = isMobile();
    };
    this.debouncedHandleResize = debounce_1(this.resizeWindow, DEBOUNCED_HANDLER_DELAY);
    this.businesses = undefined;
    this.topCategories = undefined;
    this.appActionBlocks = undefined;
    this.appLearnMoreLabel = undefined;
    this.appHmcLabel = undefined;
    this.appMostViewedProductsLabel = undefined;
    this.appProductsForYouLabel = undefined;
    this.appProductsLabel = undefined;
    this.appRangesLabel = undefined;
    this.appTopRangesForLabel = undefined;
    this.appTopTangesLabel = undefined;
    this.appToprunnerTypeNewLabel = undefined;
    this.appToprunnerTypePromotedLabel = undefined;
    this.appViewProductListLink = undefined;
    this.hideOnMobile = undefined;
    this.breadcrumbs = undefined;
    this.breadCrumbsAllProductsLabel = undefined;
    this.hmcToolsLink = undefined;
    this.productRelationsViewProdLabel = undefined;
    this.prpPriceLabel = undefined;
    this.prpTopcategoryLabel = undefined;
    this.seeAllOffersLink = undefined;
    this.viewOnLabel = undefined;
    this.hideDownloadCenterBanner = false;
    this.hideMasterRangesBanner = false;
    this.categoriesUrl = undefined;
    this.selectorConfigUrl = undefined;
    this.commerceConnectorUrl = undefined;
    this.disableBusinessLinesHashRouting = false;
    this.getCategoriesByBusinessId = undefined;
    this.getProductSelectorConfig = undefined;
    this.isPBS = false;
    this.host = undefined;
    this.showBreadcrumbs = true;
    this.atgBusinesses = undefined;
    this.countryCode = undefined;
    this.languageCode = undefined;
    this._businesses = undefined;
    this._topCategories = undefined;
    this._appActionBlocks = undefined;
    this._appLearnMoreLabel = undefined;
    this._appHmcLabel = undefined;
    this._appMostViewedProductsLabel = undefined;
    this._appProductsForYouLabel = undefined;
    this._appProductsLabel = undefined;
    this._appRangesLabel = undefined;
    this._appTopRangesForLabel = undefined;
    this._appTopTangesLabel = undefined;
    this._appToprunnerTypeNewLabel = undefined;
    this._appToprunnerTypePromotedLabel = undefined;
    this._appViewProductListLink = undefined;
    this._breadCrumbsAllProductsLabel = undefined;
    this._hmcToolsLink = undefined;
    this._productRelationsViewProdLabel = undefined;
    this._prpPriceLabel = undefined;
    this._prpTopcategoryLabel = undefined;
    this._seeAllOffersLink = undefined;
    this._viewOnLabel = undefined;
    this._hideDownloadCenterBanner = undefined;
    this._hideMasterRangesBanner = undefined;
    this._categoriesUrl = undefined;
    this._selectorConfigUrl = undefined;
    this._commerceConnectorUrl = undefined;
    this._disableBusinessLinesHashRouting = undefined;
    this._getCategoriesByBusinessId = undefined;
    this._getProductSelectorConfig = undefined;
    this.breadcrumbsFromStorage = [];
    this.storageName = '';
    this.isMobile = isMobile();
    this.businessCategoriesMap = {};
    this.activeBusinessId = null;
    this.defaultSelectorConfig = null;
    this.menuCategoryOpened = false;
    this.commerceConnectorSettings = undefined;
    this.sprykerCategoriesByBusinessId = undefined;
    this.atgCategoriesByBusinessId = undefined;
    this.CategoriesByBusinessIdwithHMC = undefined;
    this.categoriesByBusinessId = undefined;
    this.categoriesListWithHMC = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
    this.businesses = (_a = tryParse(this._businesses)) !== null && _a !== void 0 ? _a : this.businesses;
    this.topCategories = (_b = tryParse(this._topCategories)) !== null && _b !== void 0 ? _b : this.topCategories;
    this.appActionBlocks = (_c = tryParse(this._appActionBlocks)) !== null && _c !== void 0 ? _c : this.appActionBlocks;
    this.appLearnMoreLabel = (_d = tryParse(this._appLearnMoreLabel)) !== null && _d !== void 0 ? _d : this.appLearnMoreLabel;
    this.appHmcLabel = (_e = tryParse(this._appHmcLabel)) !== null && _e !== void 0 ? _e : this.appHmcLabel;
    this.appMostViewedProductsLabel = (_f = tryParse(this._appMostViewedProductsLabel)) !== null && _f !== void 0 ? _f : this.appMostViewedProductsLabel;
    this.appProductsForYouLabel = (_g = tryParse(this._appProductsForYouLabel)) !== null && _g !== void 0 ? _g : this.appProductsForYouLabel;
    this.appProductsLabel = (_h = tryParse(this._appProductsLabel)) !== null && _h !== void 0 ? _h : this.appProductsLabel;
    this.appRangesLabel = (_j = tryParse(this._appRangesLabel)) !== null && _j !== void 0 ? _j : this.appRangesLabel;
    this.appTopRangesForLabel = (_k = tryParse(this._appTopRangesForLabel)) !== null && _k !== void 0 ? _k : this.appTopRangesForLabel;
    this.appTopTangesLabel = (_l = tryParse(this._appTopTangesLabel)) !== null && _l !== void 0 ? _l : this.appTopTangesLabel;
    this.appToprunnerTypeNewLabel = (_m = tryParse(this._appToprunnerTypeNewLabel)) !== null && _m !== void 0 ? _m : this.appToprunnerTypeNewLabel;
    this.appToprunnerTypePromotedLabel = (_o = tryParse(this._appToprunnerTypePromotedLabel)) !== null && _o !== void 0 ? _o : this.appToprunnerTypePromotedLabel;
    this.appViewProductListLink = (_p = tryParse(this._appViewProductListLink)) !== null && _p !== void 0 ? _p : this.appViewProductListLink;
    this.breadCrumbsAllProductsLabel = (_q = tryParse(this._breadCrumbsAllProductsLabel)) !== null && _q !== void 0 ? _q : this.breadCrumbsAllProductsLabel;
    this.hmcToolsLink = (_r = tryParse(this._hmcToolsLink)) !== null && _r !== void 0 ? _r : this.hmcToolsLink;
    this.productRelationsViewProdLabel = (_s = tryParse(this._productRelationsViewProdLabel)) !== null && _s !== void 0 ? _s : this.productRelationsViewProdLabel;
    this.prpPriceLabel = (_t = tryParse(this._prpPriceLabel)) !== null && _t !== void 0 ? _t : this.prpPriceLabel;
    this.prpTopcategoryLabel = (_u = tryParse(this._prpTopcategoryLabel)) !== null && _u !== void 0 ? _u : this.prpTopcategoryLabel;
    this.seeAllOffersLink = (_v = tryParse(this._seeAllOffersLink)) !== null && _v !== void 0 ? _v : this.seeAllOffersLink;
    this.viewOnLabel = (_w = tryParse(this._viewOnLabel)) !== null && _w !== void 0 ? _w : this.viewOnLabel;
    this.hideDownloadCenterBanner = (_x = tryParse(this._hideDownloadCenterBanner)) !== null && _x !== void 0 ? _x : this.hideDownloadCenterBanner;
    this.hideMasterRangesBanner = (_y = tryParse(this._hideMasterRangesBanner)) !== null && _y !== void 0 ? _y : this.hideMasterRangesBanner;
    this.categoriesUrl = (_z = tryParse(this._categoriesUrl)) !== null && _z !== void 0 ? _z : this.categoriesUrl;
    this.selectorConfigUrl = (_0 = tryParse(this._selectorConfigUrl)) !== null && _0 !== void 0 ? _0 : this.selectorConfigUrl;
    this.commerceConnectorUrl = (_1 = tryParse(this._commerceConnectorUrl)) !== null && _1 !== void 0 ? _1 : this.commerceConnectorUrl;
    this.disableBusinessLinesHashRouting = (_2 = tryParse(this._disableBusinessLinesHashRouting)) !== null && _2 !== void 0 ? _2 : this.disableBusinessLinesHashRouting;
    this.getCategoriesByBusinessId = (_3 = tryParse(this._getCategoriesByBusinessId)) !== null && _3 !== void 0 ? _3 : this.getCategoriesByBusinessId;
    this.getProductSelectorConfig = (_4 = tryParse(this._getProductSelectorConfig)) !== null && _4 !== void 0 ? _4 : this.getProductSelectorConfig;
    (_5 = this.requestProductSelectorConfig()) === null || _5 === void 0 ? void 0 : _5.then((res) => {
      this.defaultSelectorConfig = res;
    });
    (_6 = this.requestCommerceConnectorSettings()) === null || _6 === void 0 ? void 0 : _6.then((res) => {
      this.commerceConnectorSettings = res;
    });
    if (this.isPBS) {
      store.set('enableAppRouting', true);
    }
    if (!isIndexDBEnabled())
      return;
    const { storageName } = getConsumerSpecificData(this.isPBS, `${this.host}${this.countryCode}/${this.languageCode}/`);
    this.storageName = storageName;
  }
  connectedCallback() {
    window.addEventListener('resize', this.debouncedHandleResize);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.debouncedHandleResize);
  }
  hasActionBlocks() {
    return this.appActionBlocks && !isEmpty(this.appActionBlocks);
  }
  renderTitle(currentBusiness) {
    if (this.isPBS) {
      return h("span", { class: "all-products__section-title" }, currentBusiness === null || currentBusiness === void 0 ? void 0 : currentBusiness.name);
    }
    return (h("a", { href: currentBusiness === null || currentBusiness === void 0 ? void 0 : currentBusiness.url, class: "all-products__section-title" }, h("span", { class: "all-products__section-title-text" }, currentBusiness === null || currentBusiness === void 0 ? void 0 : currentBusiness.name), h("pes-icon", { class: "all-products__section-title-icon", size: pesIconSizes.MICRO, mirror: pesIconMirrorDirection.HORIZONTAL }, "arrow2_left")));
  }
  render() {
    var _a, _b, _c, _d, _e;
    const activeLine = this.getActiveBusiness(this.activeBusinessId);
    const businessCategories = (_a = this.businessCategoriesMap[this.activeBusinessId]) !== null && _a !== void 0 ? _a : [];
    const isTopCategoriesActive = !this.activeBusinessId || this.isMobile;
    return (h("div", { class: "all-products" }, this.showBreadcrumbs && this.breadcrumbs && (h("pes-breadcrumbs", { breadcrumbs: this.breadcrumbs, hideOnMobile: this.hideOnMobile, hostWithLocale: this.storageName })), this.isMobile && this.hasActionBlocks() && (h("pes-action-blocks", { actionBlocks: this.appActionBlocks, selectorConfig: this.defaultSelectorConfig })), ((_b = this.businesses) === null || _b === void 0 ? void 0 : _b.length) > 0 && (h("pes-business-lines-se", { linesList: this.businesses, selectBl: this.setActiveBusinessId, topTangesLabel: this.appTopTangesLabel, viewOnLabel: this.viewOnLabel, productsLabel: this.appProductsLabel, productRelationsViewProdLabel: this.productRelationsViewProdLabel, seeAllOffersLink: this.seeAllOffersLink, mostViewedProductsLabel: this.appMostViewedProductsLabel, learnMoreLabel: this.appLearnMoreLabel, business: businessCategories, isMobile: this.isMobile, activeLine: activeLine, disableBusinessLinesHashRouting: this.disableBusinessLinesHashRouting, changeActiveLine: this.changeActiveLine, isPBS: this.isPBS, storageName: this.storageName, breadcrumbs: this.breadcrumbs || this.breadcrumbsFromStorage })), h("main", { class: classnames('all-products__main-content', {
        'all-products__main-content--menu-opened': this.menuCategoryOpened,
      }) }, h("h1", { class: "all-products__header" }, this.breadCrumbsAllProductsLabel), ((_c = this.topCategories) === null || _c === void 0 ? void 0 : _c.length) > 0 && (h("section", { class: classnames('all-products__section', {
        'all-products__section--inactive': !isTopCategoriesActive,
      }) }, h("pes-top-categories", { class: "all-products__top-categories", isActive: isTopCategoriesActive, list: this.topCategories, actionBlocks: this.appActionBlocks, viewOnLabel: this.viewOnLabel, cardCountLabel: this.appRangesLabel, isMobile: this.isMobile, selectorConfig: this.defaultSelectorConfig, hideDownloadCenterBanner: this.hideDownloadCenterBanner, hideMasterRangesBanner: this.hideMasterRangesBanner, isPBS: this.isPBS, storageName: this.storageName, breadcrumbs: this.breadcrumbs || this.breadcrumbsFromStorage }))), ((_d = this.businesses) === null || _d === void 0 ? void 0 : _d.length) > 0
      && ((_e = this.businesses) === null || _e === void 0 ? void 0 : _e.map((currentBusiness) => {
        var _a;
        const isActive = this.activeBusinessId === (currentBusiness === null || currentBusiness === void 0 ? void 0 : currentBusiness.id) && !this.isMobile;
        return (h("section", { key: (_a = currentBusiness === null || currentBusiness === void 0 ? void 0 : currentBusiness.id) !== null && _a !== void 0 ? _a : '', class: classnames('all-products__section', {
            'all-products__section--inactive': !isActive,
          }) }, h("div", { class: "all-products__section-title-wrapper" }, this.renderTitle(currentBusiness)), h("pes-menu-category", { class: "all-products__menu-category", topTangesLabel: this.appTopTangesLabel, viewOnLabel: this.viewOnLabel, productRelationsViewProdLabel: this.productRelationsViewProdLabel, seeAllOffersLink: this.seeAllOffersLink, mostViewedProductsLabel: this.appMostViewedProductsLabel, menuList: currentBusiness === null || currentBusiness === void 0 ? void 0 : currentBusiness.categories, business: businessCategories, isMobile: this.isMobile, commerceConnectorSettings: this.commerceConnectorSettings, isPBS: this.isPBS, host: this.host, storageName: this.storageName, breadcrumbs: this.breadcrumbs || this.breadcrumbsFromStorage }), h("pes-top-runners", { class: "all-products__top-runners", isActive: isActive, list: currentBusiness === null || currentBusiness === void 0 ? void 0 : currentBusiness.toprunners, viewOnLabel: this.viewOnLabel, productsLabel: this.appProductsLabel, isMobile: this.isMobile, storageName: this.storageName, breadcrumbs: this.breadcrumbs || this.breadcrumbsFromStorage })));
      })))));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "activeBusinessId": ["activeBusinessIdWatcher"]
  }; }
};
AllProducts.style = allProductsCss;

export { AllProducts as pes_all_products };
